var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetabolism(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#metabolism_svg__clip0_377_3980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 2h-3.171a3 3 0 00-5.658 0H6v4h12V2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5H3v17h9v2H2a1 1 0 01-1-1V4a1 1 0 011-1h3v2zM19 3h3a1 1 0 011 1v4h-2V5h-2V3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9h8v2H6V9zM10 13H6v2h4v-2zM6 17h4v2H6v-2zM18.609 15.128L18 15.29l-.609-.163c-2.66-.711-5.084 1.657-4.209 4.113l1.248 3.5a2 2 0 002.486 1.163L18 23.567l1.084.338a2 2 0 002.487-1.163l1.247-3.5c.875-2.457-1.549-4.825-4.209-4.114zM20.121 13.121A3 3 0 0118 14v-1a3 3 0 013-3v1a3 3 0 01-.879 2.121z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "metabolism_svg__clip0_377_3980"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgMetabolism;